module.exports = __webpack_public_path__ + "img/IT0000221754915.0a170e81.png";